var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(
      this.$route.params.object_type === 'investigator' &&
        this.$route.params.form_name === 'personalForm'
    )?_c('ProcessInvestigator'):(
      this.$route.params.object_type === 'investigator' &&
        this.$route.params.form_name === 'externalPeopleForm'
    )?_c('ProcessExternalPeople'):(
      this.$route.params.object_type === 'investigator' &&
        this.$route.params.form_name === 'newInvestigatorForm'
    )?_c('ProcessNewInvestigator'):(
      this.$route.params.object_type === 'investigator' &&
        this.$route.params.form_name === 'vinculationForm'
    )?_c('ProcessNewVinculation'):(
      this.$route.params.object_type === 'investigator' &&
        this.$route.params.form_name === 'modifyResponsibleForm'
    )?_c('ProcessModifyResponsible'):(
      this.$route.params.object_type === 'investigator' &&
        this.$route.params.form_name === 'modifyVinculationForm'
    )?_c('ProcessModifyVinculation',{attrs:{"object_type":_vm.$route.params.object_type}}):(
      this.$route.params.object_type === 'investigator' &&
        this.$route.params.form_name === 'modifyExpirationDateForm'
    )?_c('ProcessAnyConflict',{attrs:{"object_type":_vm.$route.params.object_type}}):(
      this.$route.params.object_type === 'investigator' &&
        (this.$route.params.form_name === 'modifyServicesForm'
        || this.$route.params.form_name === 'affiliationForm')
    )?_c('ProcessAnyConflict',{attrs:{"object_type":_vm.$route.params.object_type}}):(
      this.$route.params.object_type === 'investigator' &&
        (this.$route.params.form_name === 'workplaceAssignationForm' ||
          this.$route.params.form_name === 'modifyWorkplaceForm')
    )?_c('ProcessWorkplaceAssignationForm'):(this.$route.params.form_name === 'deleteRequest')?_c('ProcessAnyConflict',{attrs:{"object_type":_vm.$route.params.object_type}}):(this.$route.params.form_name === 'newArticleForm')?_c('ProcessNewArticle'):(
      this.$route.params.object_type === 'publication' &&
        this.$route.params.form_name === 'modifyBasicDataForm'
    )?_c('ProcessModifyBasicData'):(
      this.$route.params.object_type === 'publication' &&
        (this.$route.params.form_name === 'newBookAndChapterForm')
    )?_c('ProcessNewBookAndchapter'):(
      this.$route.params.object_type === 'publication' &&
        (this.$route.params.form_name === 'newThesisForm')
    )?_c('ProcessNewThesis'):(
      this.$route.params.object_type === 'publication' &&
        this.$route.params.form_name === 'newCommunicationForm'
    )?_c('ProcessCommunication'):(
      this.$route.params.object_type === 'project' &&
        (this.$route.params.form_name === 'newProjectForm' || this.$route.params.form_name === 'modifyProjectForm')
    )?_c('ProcessProject'):(
      this.$route.params.object_type === 'news'
    )?_c('ProcessAnyConflict',{attrs:{"object_type":_vm.$route.params.object_type}}):(
      this.$route.params.object_type === 'stay'
    )?_c('ProcessStay'):(this.$route.params.object_type === 'software')?_c('ProcessSoftware'):(this.$route.params.object_type === 'dataset')?_c('ProcessDataset'):(this.$route.params.object_type === 'industrial_property')?_c('ProcessIndustrialProperty'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }